<script>

export default
{
    name: 'offline',

    render () 
    {
        return (
            <div id='offline-view'>
                <img id='image' src={require('@/assets/img/satellite.svg')} />
                <div id='text'>
                    <div id='title'>Vous êtes hors-ligne</div>
                    <div id='subtitle'>Cette application a besoin d'une connexion internet pour fonctionner</div>
                </div>
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
    },

    methods:
    {
    },

    components:
    {
    }
}
</script>

<style lang='less' scoped>
@import '~@/styles/main.less';

#offline-view
{
    width: 100vw;
    height: 100vh;
    background-color: var(--theme-accent-color);
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    #image
    {
        position: absolute;
        height: 15vh;
        top: 10vh;
        animation: rotation 30s linear infinite, left-to-right 30s linear infinite;
    }

    #text
    {
        text-align: center;
        margin-left: 5vw;
        margin-right: 5vw;
        color: white;
        
        #title
        {
            font-size: 6vw;

            .OnTablet({
                font-size: 5vw;
            });

            .OnDesktop({
                font-size: 2.5vw
            });
        }

        #subtitle
        {
            margin-top: 3vh;

            .OnDesktop({
                font-size: 1vw;
            });
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Offline.vue